/* eslint-disable indent */
import { Flex } from '@chakra-ui/react'
import CategoryTitle from './components/CategoryTitle'
import { usePatchNotes } from '../../../../contexts/PatchNotes/Provider'

interface CategoryContainerProps {
  children: any
  category: 'FEATURE' | 'FIX' | 'ADJUSTMENTS' | 'ADVERTISEMENT'
}

export default function CategoryContainer({ children, category }: CategoryContainerProps) {
  const { categoriesFilters } = usePatchNotes()

  return (
    <Flex flexDir="column" p={2} gap={2} w="full" display={categoriesFilters[category] ? 'flex' : 'none'}>
      <CategoryTitle category={category} />
      <Flex w="full" flexDir={'column'} gap={4}>
        {children}
      </Flex>
    </Flex>
  )
}
